import { getLanguage } from "../../globalHelpers/LanguageHelper";
class LabelHelper {
    fetch(id, dataFields) {
        const label = window.labels ? window.labels[id] : null;

        let results = "";

        if (label) {
            const language = getLanguage();
            if (label[language]) {
                results = label[language];
            } else {
                results = label.en;
            }
        }

        if (dataFields) {
            const keys = Object.keys(dataFields);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                results = results.replace("${" + key + "}", dataFields[key]);
            }
        }

        return results;
    }
}

export default new LabelHelper();
